module.exports = __webpack_public_path__ + "static/media/brand-refresh-card-number-icon.2910b649.svg";